import styled from "styled-components";
import { menuRow, MenuRowProps } from "styles/rowStyles";

export const Box = styled.div`
  position: absolute;
  background-color: ${({ theme }) => theme.surfaceElevated};
  margin-top: 6px;
  z-index: 99999;
  box-shadow: 0 4px 16px 0 ${({ theme }) => theme.shadowColorLight};
  top: 100%;
  width: 370px;
  max-height: 300px;
  display: flex;
  justify-content: center;
  overflow-y: auto;
`;

export const InnerBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 99999;
`;

// A suggestion in the description autocomplete. It sits inside the
// declaration form and fills one row, so choosing it must not submit.
export const OptionRow = styled.button.attrs({
  type: "button",
})<MenuRowProps>`
  ${menuRow}
  flex: 1;
  max-height: 40px;
  padding: 20px;
  border-radius: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.surface};
`;

export const NoHsCodeError = styled.div`
  font-size: 14px;
  line-height: 18px;
  width: 100%;
  color: ${({ theme }) => theme.red};
  padding: 11px 20px;
`;
